// Story 8.9 (ADO-2018): one counted body scroll lock shared by every overlay that
// locks the page behind it (the Modal primitive, the cart side panel).
//
// Overlays can nest: the Clear confirm Modal opens from inside the cart side panel.
// When each saved and restored `document.body.style.overflow` on its own, React ran
// the outer (panel) cleanup before the inner (Modal) one on unmount, so the Modal
// restored the `hidden` it had captured and the page stayed locked. Counting the
// holders makes the release order irrelevant: the first lock saves the original
// value and only the last release restores it.
import { useEffect } from 'react';

let holders = 0;
let overflowBeforeFirstLock = '';

function acquire(): () => void {
  if (holders === 0) {
    overflowBeforeFirstLock = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  holders += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders -= 1;
    if (holders === 0) document.body.style.overflow = overflowBeforeFirstLock;
  };
}

/** Lock body scroll (wheel / PgDn behind an overlay) while `active` is true. */
export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    return acquire();
  }, [active]);
}
